// Slim summaries of the 3 featured guides for the landing page.
// Full content lives in data/guides.js (lazy-loaded on /guides routes) — keep slugs in sync.
export const FEATURED_GUIDES = [
  {
    slug: "ac-replacement-cost",
    category: "Cost Guide",
    h1: "AC Replacement Cost Guide (2026)",
    metaDescription: "AC replacement cost in 2026: prices by tonnage, SEER2, and job factors. Estimate it in minutes with AI — free trial, no credit card required.",
  },
  {
    slug: "how-to-estimate-hvac-jobs",
    category: "Contractor Playbook",
    h1: "How to Estimate an HVAC Job (Step by Step)",
    metaDescription: "How to estimate HVAC jobs step by step — load sizing, line items, markup, and closing on the driveway. Built by Scott Herberg, 28 years in HVAC.",
  },
  {
    slug: "furnace-replacement-cost",
    category: "Cost Guide",
    h1: "Furnace Replacement Cost Guide (2026)",
    metaDescription: "Furnace replacement cost in 2026: gas vs. electric prices, AFUE efficiency, and what changes your quote. Estimate it in minutes with AI — free trial.",
  },
];
